import type { ReactNode } from "react"
import { Icon, type IconName } from "./icons.tsx"

export function EmptyState({
  icon = "inbox",
  title,
  description,
  action,
}: {
  icon?: IconName
  title: ReactNode
  description?: ReactNode
  action?: ReactNode
}) {
  return (
    <div className="empty">
      <Icon name={icon} size={28} className="empty__icon" />
      <p className="empty__title">{title}</p>
      {description ? <p className="empty__desc">{description}</p> : null}
      {action ? <div className="empty__action">{action}</div> : null}
    </div>
  )
}
